import userInfoReducer from './userInfoReducer';
import notificationsReducer from './notificationsReducer';
import deploymentsReducer from './deploymentsReducer';
import snapshotsReducer from './snapshotsReducer';
import canvasLayersReducer, { canvasLayers } from './canvasLayersReducer';
import reportsReducer from './reportsReducer';
import assignmentGroupsPageReducer from './assignmentGroupsPageReducer';
import integrationsReducer from './integrationsReducer';
import canvasPageReducer from './canvasPageStateReducer';
import unitedCanvasReducer from './united-canvas/unitedCanvasReducer';
import commentsReducer from './commentsReducer';
import accountUsersReducer from './accountUsersReducer';
import stageDialogReducer from './funnel-flow-page/stageDialogReducer';
import newFunnelDialogReducer from './newFunnelReducer';
import { undoable } from './undoable';
import funnelMapsReducer from './funnelMapsReducer';
import { deploymentChangesUi } from './deploymentChangesUiReducer';
import { requestChangesApi } from './requestChangesApiReducer';
import { notificationsCenter } from './notificationsCenterReducers';
import sfChangeFeedReducer from './sfChangeFeedReducer';
import { crmOrgUsersSlice } from './crmOrgUsersReducer';
import salesforceDocumentationReducer from './documentation/salesforceDocumentationReducer';
import sweepFieldsReducer, { sweepFieldsInfoSlice } from '../sweep-fields/sweepFieldsInfoReducer';
import { importFunnelSlice } from './importFunnelReducer';
import { hubspotSlice } from './hubspotReducer';
import { templatesDialogSlice } from '../components/pages/funnel-map-flow/templates/dialog/templatesDialogReducer';
import { templateFieldsMappingSlice } from '../components/pages/funnel-map-flow/templates/templates-tab/templateFieldsMappingReducer';
import { devOpsCenterSlice } from './devOpsCenterReducer';
import { globalSlice } from './global/globalReducer';
import { canvasPillsSlice } from '../components/canvas-pills/canvasPillsReducer';
import { funnelSettingsDialogSlice } from '../components/pages/funnel-map-flow/dialogs/funnel-settings-dialog/funnelSettingsReducer';
import { rollupsPageSlice } from './rollupsPageReducer';
import { slackSlice } from './slackReducer';
import { roleGroupsSlice } from './roleGroupsReducer';
import { userInputsSlice } from './documentation/userInputsReducer';
import { combineReducers } from 'redux';
import { agentsHomeSlice } from '../components/aiAgentCenter/agentsHomeReducer';
import { aiAgentsSlice } from '../components/aiAgentCenter/agentsReducer';
import { agentsChatsSlice } from '../components/aiAgentCenter/agentsChatsReducer';
import environmentsReducer from '../components/pages/environments/environmentsReducer';
import { thirdPartyFunnelsSlice } from '../components/third-party-funnels/thirdPartyFunnelsReducer';
import { connectOrgSlice } from './connectOrgReducer';
import debugInfoReducer from './debugInfoReducer';
import fieldsReducer from './funnel-flow-page/fieldsReducer';
import { homepageSlice } from './homepageReducer';
import { sfLoginHistorySlice } from './loginHistoryReducer';
import territoriesReducer from './territoriesReducer';
import { bestPracticesSlice } from './bestPracticesReducer';
import { aiSupportSlice } from './aiSupportReducer';
import { promptLibrarySlice } from './promptLibraryReducer';
import documentationPageReducer, {
  documentationPageSlice,
} from './documentation/documentationPageReducer';
import documentationTopBarReducer, {
  documentationTopBarSlice,
} from './documentation/documentationTopBarReducer';
import metadataReducer, { metadataSlice } from './documentation/metadataReducer';
import { funnelStatusSlice } from './funnelStatusReducer';
import { metadataMappingSlice } from './metadataMappingReducer';
import orgMigrationReducer, { orgMigrationSlice } from './orgMigrationReducer';
import snowflakeDocumentationReducer, {
  snowflakeDocumentationSlice,
} from './documentation/snowflakeDocumentationReducer';
import data360DocumentationReducer, {
  data360DocumentationSlice,
} from './documentation/data360DocumentationReducer';
import documentationCardReducer, {
  documentationCardSlice,
} from './documentation/documentationCardReducer';
import openAiDescriptionsReducer, {
  openAiDescriptionsSlice,
} from './documentation/openAiDescriptionsReducer';
import mcpConnectionsReducer, { mcpConnectionsSlice } from './mcpConnectionsReducer';

const rootReducer = combineReducers({
  [canvasLayers.name]: canvasLayersReducer,
  environments: environmentsReducer,
  debugInfo: debugInfoReducer,
  userInfo: userInfoReducer,
  notifications: notificationsReducer,
  deployments: deploymentsReducer,
  snapshots: snapshotsReducer,
  reports: reportsReducer,
  assignmentGroupsPage: assignmentGroupsPageReducer,
  integrations: integrationsReducer,
  canvasPage: canvasPageReducer,
  unitedCanvas: unitedCanvasReducer,
  comments: undoable(commentsReducer),
  accountUsers: accountUsersReducer,
  stageDialog: stageDialogReducer,
  fieldsManagement: fieldsReducer,
  newFunnelDialog: newFunnelDialogReducer,
  funnelMaps: funnelMapsReducer,
  territories: territoriesReducer,
  sfChangeFeed: sfChangeFeedReducer,
  salesforceDocumentation: salesforceDocumentationReducer,
  [requestChangesApi.name]: requestChangesApi.reducer,
  [deploymentChangesUi.name]: deploymentChangesUi.reducer,
  [notificationsCenter.name]: notificationsCenter.reducer,
  [crmOrgUsersSlice.name]: crmOrgUsersSlice.reducer,
  [templatesDialogSlice.name]: templatesDialogSlice.reducer,
  [templateFieldsMappingSlice.name]: templateFieldsMappingSlice.reducer,
  [sweepFieldsInfoSlice.name]: sweepFieldsReducer,
  [importFunnelSlice.name]: importFunnelSlice.reducer,
  [hubspotSlice.name]: hubspotSlice.reducer,
  [devOpsCenterSlice.name]: devOpsCenterSlice.reducer,
  [globalSlice.name]: globalSlice.reducer,
  [canvasPillsSlice.name]: canvasPillsSlice.reducer,
  [funnelSettingsDialogSlice.name]: funnelSettingsDialogSlice.reducer,
  [rollupsPageSlice.name]: rollupsPageSlice.reducer,
  [slackSlice.name]: slackSlice.reducer,
  [roleGroupsSlice.name]: roleGroupsSlice.reducer,
  [userInputsSlice.name]: userInputsSlice.reducer,
  [thirdPartyFunnelsSlice.name]: thirdPartyFunnelsSlice.reducer,
  [aiAgentsSlice.name]: aiAgentsSlice.reducer,
  [agentsChatsSlice.name]: agentsChatsSlice.reducer,
  [agentsHomeSlice.name]: agentsHomeSlice.reducer,
  [connectOrgSlice.name]: connectOrgSlice.reducer,
  [homepageSlice.name]: homepageSlice.reducer,
  [sfLoginHistorySlice.name]: sfLoginHistorySlice.reducer,
  [bestPracticesSlice.name]: undoable(bestPracticesSlice.reducer),
  [aiSupportSlice.name]: undoable(aiSupportSlice.reducer),
  [promptLibrarySlice.name]: promptLibrarySlice.reducer,
  [documentationPageSlice.name]: documentationPageReducer,
  [documentationTopBarSlice.name]: documentationTopBarReducer,
  [metadataSlice.name]: metadataReducer,
  [funnelStatusSlice.name]: funnelStatusSlice.reducer,
  [metadataMappingSlice.name]: metadataMappingSlice.reducer,
  [orgMigrationSlice.name]: orgMigrationReducer,
  [snowflakeDocumentationSlice.name]: snowflakeDocumentationReducer,
  [data360DocumentationSlice.name]: data360DocumentationReducer,
  [documentationCardSlice.name]: documentationCardReducer,
  [openAiDescriptionsSlice.name]: openAiDescriptionsReducer,
  [mcpConnectionsSlice.name]: mcpConnectionsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
